'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _immutable.Map)();
  var action = arguments[1];

  switch (action.type) {
    case 'GET_UNSCHEDULED_EVENTS_START':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ loading: true }));

    case 'GET_UNSCHEDULED_EVENTS':
      return state.setIn([action.feis_id], (0, _immutable.fromJS)({ all: action.payload }));

    case 'CREATE_EVENT':
      if (state.hasIn([action.feis_id, 'all'])) {
        return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).push((0, _immutable.fromJS)(action.payload)));
      }

      return state;

    case 'SPLIT_EVENT':
      return state.setIn([action.feis_id, 'all'], (0, _immutable.fromJS)(action.payload).concat(state.getIn([action.feis_id, 'all'])).filter(function (ev) {
        return ev && ev.get('id') !== action.event_id;
      }));

    case 'MERGE_EVENT':
      return state.setIn([action.feis_id, 'all'], (state.getIn([action.feis_id, 'all']) || (0, _immutable.List)()).filter(function (ev) {
        return ev.get('id') !== action.ev_a_id && ev.get('id') !== action.ev_b_id;
      }).unshift((0, _immutable.fromJS)(action.payload)));

    case 'DELETE_EVENT':
      if (state.hasIn([action.feis_id, 'all'])) {
        return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).filter(function (ev) {
          return ev.get('id') !== action.event_id;
        }));
      }

      return state;

    case 'ATTACH_EVENT_TO_STAGE':
      if (state.hasIn([action.feis_id, 'all'])) {
        return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).filter(function (ev) {
          return ev.get('id') !== action.item.id;
        }));
      }

      return state;

    case 'DETACH_EVENT_FROM_STAGE':
      if (state.hasIn([action.feis_id, 'all'])) {
        return state.setIn([action.feis_id, 'all'], state.getIn([action.feis_id, 'all']).push((0, _immutable.fromJS)(action.item)));
      }

      return state;

    case 'DELETE_STAGE':
      return state.setIn([action.feis_id, 'all'], (state.getIn([action.feis_id, 'all']) || (0, _immutable.List)()).concat(action.events));

    default:
      return state;
  }
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/reducers/feiseanna/unscheduled-events/index.js
// module id = 702
// module chunks = 0